


<template>
    <!-- 申请退款页面 -->
    <div class="refund-wrapper">
        <div class="each-block">
            <div class="each-row mb35">
                <div class="left">退款金额</div>
                <div class="right">
                    <span class="price">￥{{data.factFee}}</span>
                </div>
            </div>
        </div>
        <div class="divider"></div>
        <div class="each-block">
            <div class="each-row mb25">
                <div class="left">退款原因</div>
            </div>
            <van-radio-group v-model="reason" v-cloak class="radios">
                <van-radio
                    checked-color="#f0bb1b"
                    shape="square"
                    v-for="(item, index) in  reasonArr"
                    :key="index"
                    :name="+index+1"
                >{{item}}</van-radio>
            </van-radio-group>
            <div class="reason-textarea-warapper" v-if="reason == 5">
                <van-field
                    v-model="reasonText"
                    class="reason-textarea"
                    type="textarea"
                    placeholder="请输入原因"
                    rows="5"
                />
                <div class="text-length">{{reasonTextLength}}/50</div>
            </div>
            <div class="submit-btn iphonex-adapt-margin" @click.stop="submit">
                <img v-if="isCostLoading" :src="loadingSrc" class="loading">
                <span v-else>申请退款</span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ApplyForRefund",
    components: {},
    props: {
        // layouts: String,
        // layoutType: String,
    },
    data() {
        return {
            refundPrice: 0, //用户输入的退款金额
            reason: 1, //radio原因类型
            reasonText: "", //选其他原因时的文本
            isCostLoading: false,
            reasons: {
                goods: [
                    "收货地址填写有误",
                    "不想要了",
                    "货物破损，拒绝签收",
                    "发货太慢",
                    "其他原因"
                ],
                others: [
                    "行程变更",
                    "买错了",
                    "天气原因",
                    "未收到电子码",
                    "其它原因"
                ]
            },
            data: {},
            loadingSrc: ""
        };
    },
    computed: {
        reasonArr() {
            if (!this.data.type) return [];
            return this.data.type === 21 || this.data.type === 22
                ? this.reasons.goods
                : this.reasons.others;
        },
        reasonTextLength() {
            return this.reasonText.length;
        }
    },
    watch: {
        refundPrice(val) {
            if (val.indexOf(".") > -1) {
                let [left, right] = val.split(".");
                if (right.length > 2) {
                    this.refundPrice = left + "." + right.substr(0, 2);
                }
            }
        }
    },
    created() {
        if (sessionStorage.refundData) {
            this.data = JSON.parse(sessionStorage.refundData);
            this.refundPrice = this.data.factFee + "";
        }
    },
    mounted() {
        this.loadingSrc = API.ossUrl + "common/loading.svg";
    },
    destroyed() {},
    methods: {
        submit() {
            if (!this.refundPrice) {
                this.$alert("申请退款金额不能为空！");
                return false;
            }
            if (this.refundPrice < 0.01) {
                this.$alert("申请退款金额不能小于0.01元！");
                return false;
            }
            if (this.refundPrice > this.data.factFee) {
                this.$alert("申请退款金额不能大于订单金额！");
                return false;
            }
            if (this.reason == 5) {
                if (this.reasonText.trim() === "") {
                    this.$alert("原因不能为空哦");
                    return false;
                }
                if (this.reasonText.length > 50) {
                    this.$alert("原因不能超过50个字！");
                    return false;
                }
            }
            this.putRefund();
        },
        putRefund() {
            if (this.isCostLoading) return;
            this.isCostLoading = true;
            let body = {
                reasonCode: this.reason,
                reasonBody: this.reason == 5 ? this.reasonText : "",
                fee: this.refundPrice - 0
            };
            this.$axios
                .put(
                    `${window.API.order.changeOrderStatus}/${
                        this.data.id
                    }?token=${sessionStorage.token}`,
                    body
                )
                .then(({ data }) => {
                    this.isCostLoading = false;
                    if (data.code == 200) {
                        this.$toast("请求申请退款成功！");
                        this.$router.go(-1);
                    } else {
                        this.$toast(data.msg);
                    }
                })
                .catch(err => console.log(err));
        }
    }
};
</script>
<style scoped lang="scss">
.refund-wrapper {
    background: $white;
    min-height: 100%;
    .divider {
        width: 100%;
        height: 2px;
        background: #f0f0f0;
    }
    .each-block {
        padding: 0.533333rem 0.4rem;
        background: $white;
        .each-row {
            display: flex;
            align-items: center;
            &:last-child {
                margin-bottom: 0px;
            }
            .left {
                color: #444444;
                font-size: 16px;
                width: 40%;
            }
            .right {
                width: 60%;
                font-size: 16px;
                display: flex;
                .price {
                    color: #444444;
                    font-size: 16px;
                    font-weight: bold;
                }
                .form-input /deep/ {
                    padding: 0px;
                    min-width: 170px;
                    input.van-field__control {
                        color: #444444;
                        font-size: 16px;
                    }
                }
            }
        }
        .radios /deep/ {
            .van-radio__input {
                font-size: 16px;
            }
            .van-radio {
                padding: 0.333333rem 0;
                .van-icon-checked {
                    color: #f0bb1b;
                }
                .van-radio__label {
                    font-size: 14px;
                    color: #333333;
                }
            }
        }
        .reason-textarea-warapper {
            position: relative;
            margin: 0.053333rem 0 0.533333rem;
            .reason-textarea {
                width: 8.933333rem;
                height: 3.92rem;
                border-radius: 0.16rem;
                border: 1px solid rgba(158, 158, 158, 0.25);
                &.van-field {
                    align-items: flex-start;
                    font-size: 0.373333rem;
                    font-family: PingFangSC-Regular;
                    font-weight: 400;
                    color: #8c8c8c;
                    line-height: 0.533333rem;
                    .van-field__body {
                        textarea::-webkit-input-placeholder {
                            font-size: 0.373333rem;
                            font-family: PingFangSC-Regular;
                            font-weight: 400;
                            color: #8c8c8c;
                            line-height: 0.533333rem;
                        }
                    }
                }
            }
            .text-length {
                position: absolute;
                bottom: 0.16rem;
                right: 0.6rem;
                font-size: 0.373333rem;
                font-family: PingFangSC-Regular;
                font-weight: 400;
                color: #8c8c8c;
                line-height: 0.533333rem;
            }
        }

        .mb35 {
            margin-bottom: 0.466667rem;
        }
        .mb25 {
            margin-bottom: 0.333333rem;
        }
        .submit-btn {
            width: 9.2rem;
            height: 1.2rem;
            margin-top: 0.8rem;
            border-radius: 0.6rem;
            background: linear-gradient(
                90deg,
                rgba(248, 199, 64, 1) 0%,
                rgba(245, 149, 38, 1) 100%
            );
            box-shadow: 0 0 15px 0px rgba(248, 199, 64, 0.49);
            // position: fixed;
            // bottom: 0.56rem;
            // left: 0;
            // right: 0;
            margin: auto;
            color: $white;
            font-size: 16px;
            display: flex;
            align-items: center;
            justify-content: center;
        }
    }
}
</style>
